import { GET_USER_BY_INVITE_TOKEN } from '../Types';

/**
 * Get a user by the token (really just gets the email, it's not a user yet)
 *
 * @param {*} token
 */
export const getByInviteToken = (token) => {
  return (dispatch) => {
    const action = {
      type: GET_USER_BY_INVITE_TOKEN,
      request: async (apiClient) => {
        const user = await apiClient.user.getByInviteToken(token);

        return user;
      },
      payload: token,
    };

    dispatch(action);
  };
};

export default getByInviteToken;
